import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { ApolloLink } from '@apollo/client';
var appReleaseLink = /*#__PURE__*/new ApolloLink(function (operation, forward) {
  operation.setContext(function (_ref) {
    var _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers;
    return {
      headers: _objectSpread(_objectSpread({}, headers), {}, {
        'creh-app-version': process.env.APP_VERSION || process.env.NEXT_PUBLIC_COMMIT_SHA,
        'creh-app-env': process.env.APP_ENV
      })
    };
  });
  return forward(operation);
});
export default appReleaseLink;